import { useEffect, useRef, useState } from 'react';
import { Col, Divider, Row, Tooltip, Typography } from 'antd'
import CustomCard from '../customs/CustomCard'
import { API_ALLAIRPORT, API_FILTER_URL, API_GET_DATA } from '../api/api';
import { axiosGet, axiosPost } from '../services/http.services';
import { ServerKeys } from '../utils/serverKeys';
import { HttpStatusCode } from 'axios';
import ProgressView from '../customs/ProgressView';
import { AllMonths, AllQuarters, getFilteredValues, getGroupedOptions, getMonthsFromQuarters, getTimestamp, parseValue } from '../helper/arrayFormatter';
import CustomButton from '../customs/CustomButton';
import { labels } from '../resources';
import MapRender from '../customs/MapRender';
import CustomSelect from '../customs/CustomSelect';
import { useFormik } from 'formik';
import dayjs from "dayjs";
import CustomDatePicker from '../customs/CustomDatePicker';
import DisplayFilterData from '../customs/DisplayFilterData';
import { useSelector } from 'react-redux';

const html2pdf = require('html2pdf.js');
const XLSX = require('xlsx');
const { saveAs } = require('file-saver');

const { Title } = Typography;

const MonthsNumber = 4
const AIRLINE_REPORT_META_FIELDS = new Set(["Airport", "Latestdate"])

const formatUpdatedTimestamp = (value) => {
	if (!value) {
		return "Not available yet";
	}

	const parsedDate = new Date(value)
	if (Number.isNaN(parsedDate.getTime())) {
		return "Not available yet";
	}

	return parsedDate?.toDateString().replace(' ', ', ') + ' ' + parsedDate?.toLocaleTimeString()
}

function ReportPage() {
	const { userData } = useSelector((state) => state.auth);
	const userAirports = userData?.airports ? JSON.parse(userData?.airports) : []
	const initialFilterValues = {
		[ServerKeys.AIRPORT]: userAirports,
		[ServerKeys.AIRLINE]: [],
		[ServerKeys.STATUS]: [],
		[ServerKeys.YEAR]: [],
		[ServerKeys.MONTH]: [],
		[ServerKeys.Date]: [],
		[ServerKeys.START_DATE]: "",
		[ServerKeys.END_DATE]: "",
		[ServerKeys.CUR_GRAPH_TYPE]: "Airport"
	}

	const initialFilterOutValues = {
		[ServerKeys.AIRPORT]: [],
		[ServerKeys.AIRLINE]: [],
		[ServerKeys.STATUS]: [],
		[ServerKeys.YEAR]: [],
		[ServerKeys.MONTH]: [],
	}
	// Airport
	const [SinceLaunchData1, setSinceLaunchData1] = useState([])
	const [SinceLaunchData2, setSinceLaunchData2] = useState([])

	const [AppPercData1, setAppPercData1] = useState([])
	const [AppPercData2, setAppPercData2] = useState([])

	const [LastMonthsData1, setLastMonthsData1] = useState([])
	const [LastMonthsData2, setLastMonthsData2] = useState([])
	const [LastMonths, setLastMonths] = useState()
	const [CustomLastMonths, setCustomLastMonths] = useState(false)

	// Airline
	const [ALSinceLaunchData1, setALSinceLaunchData1] = useState([])
	const [ALSinceLaunchData2, setALSinceLaunchData2] = useState([])
	const [ALLastMonthsData1, setALLastMonthsData1] = useState([])

	// AP-AL
	const [APALData1, setAPALData1] = useState([])
	const [APALData2, setAPALData2] = useState([])
	const [APALDataColNames1, setAPALDataColNames1] = useState([])
	const [APALDataColNames2, setAPALDataColNames2] = useState([])

	// Loadings
	const [SinceDataLoading, setSinceDataLoading] = useState(false)
	const [AppPercDataLoading, setAppPercDataLoading] = useState(false)
	const [ALSinceLaunchDataLoading, setALSinceLaunchDataLoading] = useState(false)
	const [ALLastMonthsLoading, setALLastMonthsLoading] = useState(false)
	const [APALUsageLoading, setAPALUsageLoading] = useState(false)

	// Others
	const [Dummy, setDummy] = useState(0)
	const [isDownloadPdf, setIsDownloadPdf] = useState(false)
	const [isDownloadOne, setIsDownloadOne] = useState(false)
	const [ShowMap, setShowMap] = useState(true)
	const [ShowFilterOut, setShowFilterOut] = useState(false)
	const [mergeLiveData, setMergeLiveData] = useState(false)
	const [hoveredTouchpointAirport, setHoveredTouchpointAirport] = useState("")
	const [airportOptions, setAirportOptions] = useState([]);
	const [airlineOptions, setAirlineOptions] = useState([]);
	const [MonthOptions, setMonthOptions] = useState([]);
	const [StatusOptions, setStatusOptions] = useState([]);
	const [dateFilterOptions, setDateFilterOptions] = useState([])
	const [LastUpdatedTime, setLastUpdatedTime] = useState("")
	const [AllAirportData, setAllAirportData] = useState([]);

	const isFirst = useRef(true)


	useEffect(() => {
		fetchAllAPApi()
		fetchDataApi()
	}, [])

	useEffect(() => {
		if (airlineOptions?.length > 0) {
			DashboardFilterFormik?.handleSubmit()
		}
	}, [airlineOptions])

	useEffect(() => {
		if (ShowFilterOut || isFirst.current) {
			isFirst.current = false
			return
		}

		FilterOutFormik?.resetForm({
			values: initialFilterOutValues,
		});

		// Call defualt Filter Data
		DashboardFilterFormik?.handleSubmit()
	}, [ShowFilterOut])

	const fetchAllAPApi = async () => {
		try {
			const response = await axiosGet(API_ALLAIRPORT);
			if (response?.status === 200) {
				let data = response.data;
				setAllAirportData(data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchDataApi = async () => {
		try {
			const response = await axiosGet(API_GET_DATA);
			if (response?.status === 200) {
				// console.log("Data log", response?.data);
				if (userData?.airports) {
					let tempAP = JSON.parse(userData?.airports)
					setAirportOptions(tempAP?.map(val => ({ 'label': val, 'value': val })))
				}
				else {
					setAirportOptions(response?.data?.Airport)
				}
				setAirlineOptions(response?.data?.airlines)
				setDateFilterOptions([
					getGroupedOptions(response?.data?.ytd?.map((ele) => ele?.label), labels.ytd, true),
					getGroupedOptions(response?.data?.Year?.map((ele) => ele?.label), labels.year, true),
				])

				setMonthOptions([
					getGroupedOptions(AllQuarters, labels.quarter, true),
					getGroupedOptions(AllMonths, labels.month, true),
				]);

				const tempStatus = response?.data?.Status?.filter(item => item?.label !== "WIP")
				setStatusOptions(tempStatus)

				setLastUpdatedTime(formatUpdatedTimestamp(response?.data?.LastUpdatedTime))
			}
		} catch (error) {
			console.log(error);
		}
	}


	const handleFormikChange = async (formik, key, value) => {
		await formik?.setFieldValue(key, value)
		DashboardFilterFormik.handleSubmit()
	};

	const DashboardFilterFormik = useFormik({
		enableReinitialize: true,
		initialValues: initialFilterValues,
		onSubmit: async (fitervalues) => {
			const values = { ...fitervalues }
			delete values[ServerKeys.Date]

			const startTrue = values[ServerKeys.START_DATE]
			const endTrue = values[ServerKeys.END_DATE]

			if (startTrue || endTrue) {
				let tempArr = {}
				if (startTrue) {
					tempArr["start"] = startTrue
				}

				if (endTrue) {
					tempArr["end"] = endTrue
				}

				values["Date"] = tempArr
			}
			delete values[ServerKeys.START_DATE];
			delete values[ServerKeys.END_DATE];

			if (values.MONTH_YEAR?.length > 0 && !(values.MONTH_YEAR?.every((item) => item?.startsWith("Q")) && values.MONTH_YEAR?.some((item) => item?.startsWith("Q")))) {
				values.MONTH_YEAR = getMonthsFromQuarters(values.MONTH_YEAR)
			}

			// Apply filtering logic for each field in input
			values.Airport = getFilteredValues(
				values?.Airport?.length ? values?.Airport : userAirports, 
				FilterOutFormik?.values?.Airport, 
				userAirports
			);
			values.Airport = (userAirports?.length && values?.Airport?.length === 0) ? userAirports : values.Airport
			values.Airline = getFilteredValues(values?.Airline, FilterOutFormik?.values?.Airline, airlineOptions?.map((item) => item?.value));
			values.Status = getFilteredValues(values?.Status, FilterOutFormik?.values?.Status, StatusOptions?.map((item) => item?.value));
			values.Year = getFilteredValues(values?.Year, FilterOutFormik?.values?.Year, dateFilterOptions?.[1]?.options?.map((item) => item?.value));
			values.MONTH_YEAR = getFilteredValues(values?.MONTH_YEAR, FilterOutFormik?.values?.MONTH_YEAR, AllMonths, true);

			// Initiate all API calls
			fetchTotalData(values)
			fetchAirportAirlineUsage(values)

			// Custom Year Filter Logic
			let YearMonths = [];

			if (values.MONTH_YEAR?.length > 0) {
				// If values.MONTH_YEAR has values, use those months for each year in values.Year
				setCustomLastMonths(true);
				const today = new Date();
				const currentYear = today.getFullYear();

				// If YEAR is empty, assume the current year and use the months in MONTH_YEAR
				const yearsToUse = values.Year.length > 0 ? values.Year : [currentYear]; // Default to currentYear if no Year values

				// Generate year-month combinations for all years in the Year array
				YearMonths = [];
				yearsToUse.forEach(year => {
					values.MONTH_YEAR.forEach(month => {
						YearMonths.push({ year, month });
					});
				});
			} else if (values.Year?.length === 1) {
				// If exactly one year is selected, generate the year and last months for that year
				const selectedYear = values.Year[0];
				YearMonths = getYearAndLastMonths(MonthsNumber, selectedYear);  // Pass the selected year
				setCustomLastMonths(true);
			} else if (values.MONTH_YEAR?.length === 0 && values?.["Date"]?.end) {
				const endDate = new Date(values["Date"].end);

				const endYear = endDate.getFullYear();
				const endMonth = endDate.getMonth(); // 0-based

				const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

				YearMonths = [];

				// Generate MonthsNumber months backward from the endDate
				for (let i = 0; i < MonthsNumber; i++) {
					const monthIndex = (endMonth - i + 12) % 12;
					const year = (endMonth - i < 0) ? endYear - 1 : endYear;
					const monthName = monthNames[monthIndex];

					YearMonths.push({ year, month: monthName });
				}

				// Reverse to make it chronological (earliest to latest)
				YearMonths.reverse();

				setCustomLastMonths(true);
			} else {
				// If there are no months selected in MONTH_YEAR and no year selected, continue the flow
				YearMonths = getYearAndLastMonths(MonthsNumber);
				setCustomLastMonths(false);
			}

			if (values?.["Date"]) {
				const startDate = values["Date"].start ? dayjs(values["Date"].start).startOf("day") : null;
				const endDate = values["Date"].end ? dayjs(values["Date"].end).endOf("day") : null;

				// Function to check if a year-month object is within the date range
				const isWithinRange = (year, month) => {
					const monthIndex = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].indexOf(month);
					if (monthIndex === -1) {
						return false;
					}

					const monthStartDate = dayjs(new Date(year, monthIndex, 1)).startOf("month");
					const monthEndDate = monthStartDate.endOf("month");

					if (startDate && monthEndDate.isBefore(startDate)) {
						return false;
					}

					if (endDate && monthStartDate.isAfter(endDate)) {
						return false;
					}

					return true;
				};

				// Filter the YearMonths array based on the start and end dates
				YearMonths = YearMonths.filter(item => isWithinRange(item.year, item.month));
			}

			setLastMonths(YearMonths);
			fetchLast3Months(YearMonths, values);
			fetchALTotalData(YearMonths, values);
			fetchALLast3Months(YearMonths, values);
		}
	});

	const FilterOutFormik = useFormik({
		enableReinitialize: true,
		initialValues: initialFilterOutValues,
		onSubmit: (values) => {
			DashboardFilterFormik.handleSubmit()
		}
	});

	function getYearAndLastMonths(MonthsNumber, selectedYear) {
		const today = new Date();
		const currentYear = today.getFullYear();
		const currentMonth = today.getMonth();  // 0-based (Jan = 0, Dec = 11)
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const lastTempMonths = [];

		let startYear = selectedYear || currentYear;  // Default to current year if no year is provided
		let startMonth = currentMonth;  // Start from the current month if no year is provided

		// If we have a selected year, we will calculate months backwards from September
		if (selectedYear) {
			startMonth = 11; // Dec (index 11)
		}

		// Generate months backwards, starting from September for the selected year
		for (let i = 0; i < MonthsNumber; i++) {
			const monthIndex = (startMonth - i + 12) % 12; // Wrap around the months when going back
			const monthName = monthNames[monthIndex];

			const year = (startMonth - i < 0) ? startYear - 1 : startYear; // Handle the previous year case
			lastTempMonths.push({ year, month: monthName });
		}

		// Reverse to start from the most recent month
		lastTempMonths.reverse();

		return lastTempMonths;
	}


	function customSort(arr, order) {
		const orderIndex = {};
		order.forEach((loc, index) => {
			orderIndex[loc] = index;
		});

		// Sort the input array based on the index of each location in the order array
		arr?.sort((a, b) => {
			const locA = a[0]; // Location of the first element
			const locB = b[0]; // Location of the second element

			return orderIndex[locA] - orderIndex[locB];
		});

		return arr;
	}

	function sort3MonthData(temp1) {
		let data = temp1[0]
		let allAirports = new Set();

		for (let index = 1; index < data?.[0]?.length; index++) {
			let sortedData = [...data];
			let firstItem = sortedData.shift()

			sortedData = sortedData?.sort((a, b) => b?.[index] - a?.[index]);
			if (index === 1) {
				sortedData?.unshift(firstItem)
				temp1[0] = sortedData
			}
		}

		for (let index = 0; index < temp1.length; index++) {
			const eachArray = temp1[index];
			for (let index = 0; index < eachArray.length; index++) {
				const eachRow = eachArray[index];
				allAirports.add(eachRow[0])
			}
		}

		let AP_order = []
		for (let index = 0; index < temp1[0]?.length; index++) {
			const element = temp1[0][index];
			AP_order.push(element[0]);
		}

		// Loop through all items in the allAirports set
		allAirports.forEach(airport => {
			// Check if the airport is not already in the AP_order array
			if (!AP_order.includes(airport)) {
				// Add the airport to AP_order
				AP_order.push(airport);
			}
		});

		for (let monthIndex = 0; monthIndex < temp1?.length; monthIndex++) {
			const EachMonthData = temp1[monthIndex];

			// Find missing airports and append them to EachMonthData
			let existingAirports = EachMonthData.map(row => row[0]);
			let missingAirports = AP_order.filter(airport => !existingAirports.includes(airport));

			missingAirports.forEach(airport => {
				// Create a new row with default data (e.g., zeros) for the missing airport
				let newRow = [airport, ...Array(EachMonthData?.[0].length - 1).fill(0)];
				EachMonthData.push(newRow);
			});

			// Sort data based on the AP_order and update the month data
			data = customSort(EachMonthData, AP_order);

			// Remove the first element (airport name) after sorting
			if (monthIndex > 0) {
				for (let rowIndex = 0; rowIndex < data?.length; rowIndex++) {
					data[rowIndex]?.shift();
				}
			}

			temp1[monthIndex] = data;
		}

		return temp1
	}

	const calculateAggregate = (arr) => {
		const aggregates = {};

		// Loop through each date's data
		arr.forEach(dateData => {
			dateData.forEach(entry => {
				let [location, totalPassengers, DYPercent, AppPercent] = entry;

				if (isNaN(AppPercent)) {
					AppPercent = 0
				}


				// If location does not exist in the aggregates, initialize it
				if (!aggregates[location]) {
					aggregates[location] = {
						totalPassengers: 0,
						totalDYPercent: 0,
						totalAppPercent: 0
					};
				}

				// Aggregate the total passengers, male passengers, and female passengers
				let temptotalPassengers = aggregates[location].totalPassengers || 0
				aggregates[location].totalPassengers = temptotalPassengers + totalPassengers;

				let temptotalDYPercent = aggregates[location].totalDYPercent || 0
				aggregates[location].totalDYPercent = temptotalDYPercent + totalPassengers * (DYPercent / 100);

				let temptotalAppPercent = aggregates[location].totalAppPercent || 0
				aggregates[location].totalAppPercent = temptotalAppPercent + totalPassengers * (AppPercent / 100);
			});
		});

		// Now calculate the final aggregated percentages
		const finalAggregates = Object.keys(aggregates).map(location => {
			const data = aggregates[location];
			const totalPassengers = data.totalPassengers;

			const totalDYPercent = ((data.totalDYPercent / totalPassengers) * 100) || 0;
			const totalAppPercent = ((data.totalAppPercent / totalPassengers) * 100) || 0;

			// Round the percentages to 2 decimal places
			return [
				location,
				totalPassengers,
				parseFloat(totalDYPercent.toFixed(2)),
				parseFloat(totalAppPercent.toFixed(2))
			];
		});

		// Output the result
		return simpleSort(finalAggregates)
	}

	const simpleSort = (temp) => {
		if (temp?.length === 0) {
			return temp
		}

		const index = 1
		let firstItem = temp?.shift()
		temp = temp?.sort((a, b) => b?.[index] - a?.[index]);
		temp?.unshift(firstItem)
		return temp
	}

	const fetchTotalData = async (FilterValues) => {
		setSinceDataLoading(true)
		let tempFilter = { ...FilterValues };

		const liveResults1 = [];
		if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live1")) {
			let tempFilter1 = { ...tempFilter, Status: ["Live1"] };
			await makeAPICall(tempFilter1, liveResults1)
		}

		const liveResults2 = [];
		if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live2")) {
			let tempFilter2 = { ...tempFilter, Status: ["Live2"] };
			await makeAPICall(tempFilter2, liveResults2)
		}

		setSinceLaunchData1(liveResults1?.length === 0 ? [] : simpleSort(liveResults1?.[0]))
		setSinceLaunchData2(liveResults2?.length === 0 ? [] : simpleSort(liveResults2?.[0]))

		setSinceDataLoading(false)
	}

	const fetchAirportAirlineUsage = async (FilterValues) => {
		setAPALUsageLoading(true)
		let tempAirline = airlineOptions?.map((item) => item?.value)

		let tempFilter = { ...FilterValues };
		tempFilter.Airline = getFilteredValues(tempAirline, FilterOutFormik?.values?.Airline, tempAirline);

		let tempFilter1 = { ...tempFilter, Status: ["Live1"] };
		let liveResults1 = []
		if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live1")) {
			liveResults1 = await makeAPICall(tempFilter1, undefined, true);
		}

		let keys1 = []
		try {
			keys1 = Object.keys(liveResults1?.[0]);
		} catch (error) {
			keys1 = []
		}

		// Remove the last 9 keys
		liveResults1?.forEach((item) => {
			keys1.slice(-8).forEach(key => {
				delete item[key];
			});
			delete item["Latestdate"]
			delete item["AIRLINE SUM"]
		});

		let tempFilter2 = { ...tempFilter, Status: ["Live2"] };
		let liveResults2 = []
		if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live2")) {
			liveResults2 = await makeAPICall(tempFilter2, undefined, true);
		}

		let keys2 = []
		try {
			keys2 = Object.keys(liveResults2?.[0]);
		} catch (error) {
			keys2 = []
		}

		// Remove the last 9 keys
		liveResults2?.forEach((item) => {
			keys2.slice(-8).forEach(key => {
				delete item[key];
			});
			delete item["Latestdate"]
			delete item["AIRLINE SUM"]
		});

		// Helper function to sort the object by its values in descending order
		const sortFirstRow = (firstRow) => {
			if (!firstRow) {
				return []
			}
			let sortedKeys = Object.keys(firstRow)
				.filter(key => key !== 'Airport') // Remove the Airport key from sorting
				.sort((a, b) => parseValue(firstRow[b]) - parseValue(firstRow[a])); // Sort in descending order based on value
			return ['Airport', ...sortedKeys]; // Return the sorted keys with 'Airport' at the front
		};

		// Sort the first row of liveResults1 and liveResults2 to get the correct column order
		let sortedColumnNames1 = sortFirstRow(liveResults1?.[0]);
		let sortedColumnNames2 = sortFirstRow(liveResults2?.[0]);

		// Set column names for display (the sorted keys)
		setAPALDataColNames1(sortedColumnNames1);
		setAPALDataColNames2(sortedColumnNames2);

		// Function to reorder the rows based on the new column order
		const reorderRows = (rows, sortedColumns) => {
			return rows.map(row =>
				sortedColumns.map(col => {
					if (col === 'Airport') {
						return row[col];
					}

					return parseValue(row[col])
				})
			);
		};

		// Reorder both liveResults1 and liveResults2 based on the sorted columns
		let finalData1 = reorderRows(liveResults1, sortedColumnNames1);
		let finalData2 = reorderRows(liveResults2, sortedColumnNames2);

		// Update the state with the final sorted data
		setAPALData1(finalData1?.length === 0 ? [] : simpleSort(finalData1));
		setAPALData2(finalData2?.length === 0 ? [] : simpleSort(finalData2));

		setAPALUsageLoading(false);
	};


	const formatAirlineData = async (data) => {
		if (!data) {
			return []
		}

		let tempArr = []

		try {
			const Entries = Object.entries(data)

			for (let index = 0; index < Entries?.length; index++) {
				const [key, value] = Entries[index];
				if (AIRLINE_REPORT_META_FIELDS.has(key) || key?.startsWith("_")) {
					continue
				}

				const parsedMetric = parseValue(value)
				const isMissingMetric = value === null || value === undefined || value === ""

				if (!Number.isFinite(parsedMetric) && !isMissingMetric) {
					continue
				}

				tempArr.push([key, Number.isFinite(parsedMetric) ? parsedMetric : 0])
			}

			return tempArr
		} catch (error) {
			console.log(error);
			return []
		}
	}

	const calculateDYPercAL = async (liveResults) => {
		for (let index = 0; index < liveResults?.length; index++) {
			const element = liveResults[index];
			let AppPerc = element[1] / liveResults?.[0][1] * 100
			AppPerc = (AppPerc % 1 === 0) ? AppPerc.toFixed(0) : AppPerc.toFixed(2);
			if (AppPerc > 100) {
				AppPerc = 100
			}

			if (isNaN(AppPerc)) {
				AppPerc = 0
			}

			element.push(AppPerc)
		}
	}

	const fetchALTotalData = async (YearMonths, FilterValues) => {
		setALSinceLaunchDataLoading(true);

		// Create a list of years from the YearMonths array
		const years = FilterValues?.Year?.length === 0 ? [YearMonths[YearMonths?.length - 1]?.year]
			:
			FilterValues?.Year

		let tempFilter = { ...FilterValues };
		tempFilter[ServerKeys.CUR_GRAPH_TYPE] = "Airline";

		let liveResults1 = [];
		try {
			let tempFilter1 = { ...tempFilter };
			tempFilter1["Year"] = [];
			const data = await makeAPICall(tempFilter1, undefined, true);
			liveResults1 = await formatAirlineData(data?.[0]);
			const sum1 = liveResults1?.reduce((partialSum, a) => partialSum + a[1], 0);
			liveResults1?.unshift(["TOTAL", sum1]);

			await calculateDYPercAL(liveResults1);
		} catch (error) {
			liveResults1 = [];
		}

		let liveResultsByYear = {}; // To hold the results for each year in the format {year: data}
		try {
			// Loop through each year and fetch the corresponding data
			for (const year of years) {
				let tempFilter2 = { ...tempFilter, Year: [year] };
				const data2 = await makeAPICall(tempFilter2, undefined, true);
				let liveResults2 = await formatAirlineData(data2[0]);
				const sum2 = liveResults2?.reduce((partialSum, a) => partialSum + a[1], 0);
				liveResults2?.unshift(["TOTAL", sum2]);

				await calculateDYPercAL(liveResults2);

				// Store the results for each year in liveResultsByYear
				liveResultsByYear[year] = simpleSort(liveResults2.filter(item => item?.length));
			}
		} catch (error) {
			liveResultsByYear = {};
		}

		// Set the liveResults1 and liveResultsByYear (ALSinceLaunchData1 and ALSinceLaunchData2)
		setALSinceLaunchData1(simpleSort(liveResults1.filter(item => item?.length)));
		setALSinceLaunchData2(liveResultsByYear);

		setALSinceLaunchDataLoading(false);
	}


	const filterFetch = async (year, month, Status, liveResults, FilterValues) => {
		let tempFilter = { ...FilterValues };
		let filterForLive = { ...tempFilter, Year: [year], MONTH_YEAR: [month], Status: [Status] };
		const data = await makeAPICall(filterForLive, liveResults, true);
		liveResults.push(data)
	}

	const format3MonthsPerc = async (liveResults, temp) => {
		for (let index = 0; index < liveResults?.length; index++) {
			const data = liveResults[index];

			const finalData = []

			for (let index = 0; index < data?.length; index++) {
				let tempArr = []
				const element = data[index];

				const TotalPax = parseValue(element["total_pax"])
				let AppPerc = parseFloat(parseValue(element["entry_via_app"]) / parseValue(element["dy_pax"]) * 100);
				AppPerc = (AppPerc % 1 === 0) ? AppPerc.toFixed(0) : AppPerc.toFixed(2);

				if (AppPerc > 100) {
					AppPerc = 100
				}

				if (isNaN(AppPerc)) {
					AppPerc = 0
				}

				tempArr.push(element["Airport"])
				tempArr.push(TotalPax)
				tempArr.push(parseValue(element["dy_perc"]))
				tempArr.push(AppPerc)
				finalData.push(tempArr)
			}

			temp.push(finalData)
		}
	}

	const format3MonthsEntry = async (liveResults, temp) => {
		for (let index = 0; index < liveResults?.length; index++) {
			const data = liveResults[index];

			const finalData = []

			for (let index = 0; index < data?.length; index++) {
				let tempArr = []
				const element = data[index];

				tempArr.push(element["Airport"])
				tempArr.push(parseValue(element["dy_pax"]))
				tempArr.push(parseValue(element["pax_pesc"]))
				tempArr.push(parseValue(element["pax_boarding"]))
				finalData.push(tempArr)
			}

			temp.push(finalData)
		}
	}

	const fetchLast3Months = async (YearMonths, FilterValues) => {
		setAppPercDataLoading(true)
		const liveResults1 = [];
		const liveResults2 = [];


		for (let index = 0; index < YearMonths?.length; index++) {
			const { year, month } = YearMonths?.[index];

			if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live1")) {
				await filterFetch(year, month, "Live1", liveResults1, FilterValues)
			}

			if (FilterValues?.Status?.length === 0 || FilterValues?.Status?.includes("Live2")) {
				await filterFetch(year, month, "Live2", liveResults2, FilterValues)
			}
		}


		const temp1 = []
		const temp2 = []

		await format3MonthsPerc(liveResults1, temp1)
		await format3MonthsPerc(liveResults2, temp2)


		setAppPercData1(calculateAggregate(temp1));
		setAppPercData2(calculateAggregate(temp2));


		const tempEntry1 = [];
		const tempEntry2 = [];

		await format3MonthsEntry(liveResults1, tempEntry1)
		await format3MonthsEntry(liveResults2, tempEntry2)

		setLastMonthsData1(sort3MonthData(tempEntry1.filter(item => item?.length)))
		setLastMonthsData2(sort3MonthData(tempEntry2.filter(item => item?.length)))

		setAppPercDataLoading(false)
	}


	const filterALFetch = async (year, month, liveResults, FilterValues) => {
		let tempFilter = { ...FilterValues };
		tempFilter[ServerKeys.CUR_GRAPH_TYPE] = "Airline"
		let filterForLive = { ...tempFilter, Year: [year], MONTH_YEAR: [month] };
		const data = await makeAPICall(filterForLive, liveResults, true);
		liveResults.push(data)
	}

	const fetchALLast3Months = async (YearMonths, FilterValues) => {
		setALLastMonthsLoading(true)
		const liveResults1 = [];

		for (let index = 0; index < YearMonths?.length; index++) {
			const { year, month } = YearMonths?.[index];

			await filterALFetch(year, month, liveResults1, FilterValues)
		}


		const tempEntry1 = [];
		for (let index = 0; index < liveResults1?.length; index++) {
			try {
				const element = liveResults1[index];
				const data = await formatAirlineData(element[0])
				const sum2 = data?.reduce((partialSum, a) => partialSum + a[1], 0) || 0;
				data?.unshift(["TOTAL", sum2])
				tempEntry1.push(data)
				await calculateDYPercAL(tempEntry1[index])
			} catch (error) {
				console.log(error);
			}
		}

		setALLastMonthsData1(sort3MonthData(tempEntry1))
		setALLastMonthsLoading(false)
	}

	// Reset form to initial values when needed
	const resetFormToInitialValues = () => {
		const tempInitValues = { ...initialFilterValues }

		DashboardFilterFormik.resetForm({
			values: tempInitValues,
		});

		DashboardFilterFormik.handleSubmit()
		setDummy(val => val + 1)
		setShowFilterOut(false)
	};


	const makeAPICall = async (fitervalues, setData, returnData = false) => {
		const isSetFuncBool = typeof setData === "function"
		const values = { ...fitervalues }

		delete values[ServerKeys.START_DATE];
		delete values[ServerKeys.END_DATE];

		try {
			const curUrl = API_FILTER_URL;
			const response = await axiosPost(curUrl, values)
			if (response?.status === HttpStatusCode.Ok) {
				// console.log("Filter Resp: ", response.data);
				const data = response.data
				let finalData = []

				if (returnData || data?.length === 0) {
					return data
				}

				for (let index = 0; index < data?.length; index++) {
					let tempArr = []
					const element = data[index];

					tempArr.push(element["Airport"])
					tempArr.push(values?.Airline?.length > 0 ? parseValue(element["AIRLINE SUM"]) : parseValue(element["dy_pax"]))
					tempArr.push(parseValue(element["pax_pesc"]))
					tempArr.push(parseValue(element["pax_boarding"]))
					finalData.push(tempArr)
				}

				if (isSetFuncBool) {
					setData(finalData)
				}
				else {
					setData?.push(finalData)
				}
			}
		} catch (error) {
			console.log(error || "Something went wrong")
		}
	}

	const downloadPageAsPdf = (idName, exportName) => {
		setIsDownloadPdf(true)
		let element;

		if (idName) {
			setIsDownloadOne(true)
			// select component from document id
			element = document.getElementById(idName);
		}
		else {
			element = document.getElementById("MainView");
		}

		// Calculate content size
		const contentWidth = element.offsetWidth;
		const contentHeight = element.offsetHeight;

		const scaleFactor = 0.37; // Adjust scale to fit content within page
		const pdfWidth = contentWidth * 0.3;
		const pdfHeight = contentHeight * scaleFactor;

		const options = {
			image: { type: 'jpeg', quality: 1 },
			margin: idName ? 5 : 0,
			html2canvas: {
				scale: 3,
				letterRendering: true,
				logging: false
			},
			jsPDF: {
				unit: 'mm',
				// format: [pdfWidth, pdfHeight],
				format: idName ? mergeLiveData ? [pdfWidth, pdfHeight] : [210, 350] : [320, 490],
				orientation: 'landscape'
			}
		};

		const timestamp = getTimestamp();
		const filename = `${idName ? exportName : 'DY-Report'}_${timestamp}.pdf`;

		// Generate the PDF
		html2pdf()
			.from(element)
			.set(options)
			.save(filename);

		setTimeout(() => {
			setIsDownloadPdf(false)
			setIsDownloadOne(false)
		}, 500);
	};


	const exportToExcel = (name, TableData, preferredOrder) => {
		const wb = XLSX.utils.book_new();

		const entries = Object.entries(TableData)
		for (let index = 0; index < entries?.length; index++) {
			const [name, value] = entries[index];
			value?.unshift(preferredOrder)
			const ws = XLSX.utils.json_to_sheet(value);
			XLSX.utils.book_append_sheet(wb, ws, name);
		}

		// Generate Excel file
		const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const timestamp = getTimestamp();
		const filename = `${name}_${timestamp}.xlsx`;
		saveAs(new Blob([excelFile]), filename);
	};

	const RenderLastSoMonths = () => {
		if (CustomLastMonths) {
			return null
		}

		return <span className='ml-5'>{`* Last ${MonthsNumber} Month Data of 2025${DashboardFilterFormik.values?.Year?.length > 0 ? ", Select Month Filter for custom months" : ""}`}</span>
	}

	const RenderTitle = ({ title, idName, exportName, exportData, style = {}, preferredOrder }) => {
		return (
			<>
				{isDownloadPdf && isDownloadOne && <DisplayFilterData initialFilterOutValues={FilterOutFormik?.values} initialFilterValues={DashboardFilterFormik?.values} />}

				<div style={{ position: "relative", ...style }}>
					<Title level={4} style={{ borderRadius: "5px 25px", padding: "5px 25px", marginTop: isDownloadPdf ? isDownloadOne ? "-10px" : 0 : 20, textAlign: "center" }}>
						{title}
					</Title>

					{!isDownloadPdf && <div style={{ position: "absolute", top: 7, right: 30 }}>
						<CustomButton className="ml-2" icon={<img src={require("../assests/download.png")} alt="download" loading="lazy"
							style={{ width: 15, height: 15 }} />}
							label={"PDF"}
							onClick={() => downloadPageAsPdf(idName, exportName)}
						/>

						<CustomButton className="ml-2" icon={<img src={require("../assests/download.png")} alt="download" loading="lazy"
							style={{ width: 15, height: 15 }} />}
							label={"XLSX"}
							onClick={() => exportToExcel(exportName, exportData, preferredOrder)}
						/>
					</div>}
				</div>

				<Divider style={{ margin: 20, marginBottom: 0 }} />
			</>
		)
	}

	const mergeLiveDataArrays = (data1, data2) => {
		if (!data1?.length && !data2?.length) return [];
		if (!data1?.length) return data2;
		if (!data2?.length) return data1;

		const mergedMap = new Map();

		// Process first array
		data1.forEach(item => {
			const key = item[0]; // Airport/Airline name
			mergedMap.set(key, [...item]);
		});

		// Merge with second array
		data2.forEach(item => {
			const key = item[0];
			if (mergedMap.has(key)) {
				const existing = mergedMap.get(key);
				// Add values for each column except the first one (name)
				for (let i = 1; i < item.length; i++) {
					existing[i] = (parseFloat(existing[i]) || 0) + (parseFloat(item[i]) || 0);
				}
			} else {
				mergedMap.set(key, [...item]);
			}
		});

		return simpleSort(Array.from(mergedMap.values()));
	};

	const getTouchpointRowProps = (row) => {
		if (isDownloadPdf) {
			return {};
		}

		const airportCode = row?.[0];
		if (!airportCode || airportCode === "TOTAL") {
			return {};
		}

		return {
			onMouseEnter: () => setHoveredTouchpointAirport(airportCode),
			onMouseLeave: () => setHoveredTouchpointAirport((current) => (current === airportCode ? "" : current)),
		};
	};

	return (
		<CustomCard>

			{/* Filters View */}
			<div style={{ display: "flex", marginBottom: -15 }}>
				<div style={{ flex: 1 }}>
					<Row gutter={[3, 20]} className={ShowFilterOut ? "mb-3" : "mb-4"} key={Dummy} style={{ alignItems: "flex-end" }}>
						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.AIRPORT}
								label={labels.Airport}
								options={airportOptions}
								value={DashboardFilterFormik.values?.airport}
								onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.AIRPORT, option)}
								mode="multiple"
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.AIRLINE}
								label={labels.airline}
								value={DashboardFilterFormik.values[ServerKeys.AIRLINE]}
								options={airlineOptions}
								mode="multiple"
								onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.AIRLINE, option)}
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.STATUS}
								label={labels.status}
								options={StatusOptions}
								value={DashboardFilterFormik.values?.status}
								onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.STATUS, option)}
								mode="multiple"
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								label={labels.year}
								value={DashboardFilterFormik.values[ServerKeys.YEAR]}
								options={dateFilterOptions}
								mode="multiple"
								onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.YEAR, option)}
							/>
						</Col>


						<Col className="mr-3">
							<CustomSelect
								label={labels.month}
								value={DashboardFilterFormik.values[ServerKeys.MONTH]}
								options={MonthOptions}
								mode="multiple"
								onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.MONTH, option)}
							/>
						</Col>

						<Col className="mr-3">
							<CustomDatePicker
								name={ServerKeys.START_DATE}
								label={labels.startDate}
								value={DashboardFilterFormik?.values?.startDate}
								placeholder="Select Date"
								onChange={(selectedDate) => handleFormikChange(
									DashboardFilterFormik,
									ServerKeys.START_DATE,
									selectedDate ? selectedDate.format("YYYY-MM-DD") : ""
								)}
								disableDate={(date) => {
									return dayjs(date).isAfter(dayjs(DashboardFilterFormik?.values?.endDate), "day");
								}}
							/>
						</Col>

						<Col className="mr-3">
							<CustomDatePicker
								name={ServerKeys.END_DATE}
								label={labels.endDate}
								placeholder="Select Date"
								value={DashboardFilterFormik?.values?.endDate}
								onChange={(selectedDate) => handleFormikChange(
									DashboardFilterFormik,
									ServerKeys.END_DATE,
									selectedDate ? selectedDate.format("YYYY-MM-DD") : ""
								)}
								disableDate={(date) => {
									return dayjs(date).isBefore(dayjs(DashboardFilterFormik?.values?.startDate), "day");
								}}
							/>
						</Col>

						<Col>
							<CustomButton
								label={labels.clearAll}
								onClick={resetFormToInitialValues}
								disabled={!airportOptions?.length}
							/>
						</Col>

						<Col>
							<CustomButton className={`ml-2 ${ShowFilterOut ? "bg-[#ff3b3b]" : ""}`}
								label={"Filter Out"}
								onClick={() => setShowFilterOut(val => !val)}
								disabled={!airportOptions?.length}
							/>
						</Col>
					</Row>

					{ShowFilterOut && <Row gutter={[3, 20]} className="mb-4" key={Dummy + 5} style={{ alignItems: "flex-end" }}>
						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.AIRPORT}
								label={labels.Airport}
								options={airportOptions}
								value={FilterOutFormik.values?.airport}
								onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.AIRPORT, option)}
								mode="multiple"
								placeholder={`${labels.exclude}`}
								lableClassName="text-red font-semibold"
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.AIRLINE}
								label={labels.airline}
								value={FilterOutFormik.values[ServerKeys.AIRLINE]}
								options={airlineOptions}
								placeholder={`${labels.exclude}`}
								lableClassName="text-red font-semibold"
								mode="multiple"
								onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.AIRLINE, option)}
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								name={ServerKeys.STATUS}
								label={labels.status}
								options={StatusOptions}
								value={FilterOutFormik.values?.status}
								onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.STATUS, option)}
								mode="multiple"
								placeholder={`${labels.exclude}`}
								lableClassName="text-red font-semibold"
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								label={labels.year}
								value={FilterOutFormik.values[ServerKeys.YEAR]}
								placeholder={`${labels.exclude}`}
								lableClassName="text-red font-semibold"
								options={[dateFilterOptions?.[1]]}
								mode="multiple"
								onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.YEAR, option)}
								disabled={DashboardFilterFormik.values[ServerKeys.YEAR]?.includes("YTD") && !(FilterOutFormik.values[ServerKeys.YEAR]?.some((item) => DashboardFilterFormik.values[ServerKeys.YEAR]?.includes(item)))}
							/>
						</Col>

						<Col className="mr-3">
							<CustomSelect
								label={labels.month}
								value={FilterOutFormik.values[ServerKeys.MONTH]}
								placeholder={`${labels.exclude}`}
								lableClassName="text-red font-semibold"
								options={MonthOptions}
								mode="multiple"
								onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.MONTH, option)}
							/>
						</Col>

						<Tooltip title="Note: Selecting same values in Filter and Exclusion cancels each other. Some filter values are over ridden based on the views.">
							<span style={{ fontSize: 14, fontWeight: "bold", fontStyle: "italic", color: '#1890ff', borderRadius: 20, borderWidth: 2, padding: 5, paddingInline: 13, cursor: "default" }}>i</span>
						</Tooltip>
					</Row>}
					<div>
						<CustomButton className={`ml-2 ${mergeLiveData ? "bg-[#ff3b3b]" : ""}`}
							label={mergeLiveData ? "Unmerge Live Status" : "Merge Live Status"}
							onClick={() => setMergeLiveData(val => !val)}
							disabled={!airportOptions?.length}
						/>
					</div>
				</div>

				<div style={{ margin: 10, height: "fit-content" }}>
					<CustomButton className='p-3 py-2 mt-1'
						label={"Export Data"}
						onClick={() => downloadPageAsPdf()}
						disabled={SinceDataLoading || AppPercDataLoading || ALSinceLaunchDataLoading || ALLastMonthsLoading || APALUsageLoading}
					/>
				</div>
			</div>


			{/* Main Report View */}
			<div id='MainView'>
				{isDownloadPdf && <DisplayFilterData initialFilterOutValues={FilterOutFormik?.values} initialFilterValues={DashboardFilterFormik?.values} />}

				<div id='SinceLaunchData1' className='html2pdf__page-break'>
					<RenderTitle title="DY Touch Points"
						idName="SinceLaunchData1" exportName={"DY Touch Points"}
						exportData={{ "Live1": SinceLaunchData1, "Live2": SinceLaunchData2 }}
						preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: (isDownloadPdf || !ShowMap) ? "repeat(2, 1fr)" : "repeat(3, 1fr)", gap: "10px" }}>
						{!isDownloadPdf && <div style={{
							transition: "top 0.3s ease", position: "absolute",
							top: 20, right: 10, zIndex: 99
						}}>
							<CustomButton
								name={ShowMap ? "Hide Map" : "Show Map"}
								label={ShowMap ? "✘" : "✚"}
								onClick={() => setShowMap(val => !val)}
							/>
						</div>}

						{mergeLiveData ? (
							<ProgressView title='Combined Live Data' sorter isDownloadPdf={isDownloadPdf}
								data={mergeLiveDataArrays(SinceLaunchData1, SinceLaunchData2)} isLoading={SinceDataLoading}
								preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
								onRow={getTouchpointRowProps}
								rowHoverable={!isDownloadPdf}
							/>
						) : (
							<>
								{(SinceLaunchData1?.length > 0 || SinceDataLoading) && <ProgressView title='Live1' sorter isDownloadPdf={isDownloadPdf}
									data={SinceLaunchData1} isLoading={SinceDataLoading}
									preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
									onRow={getTouchpointRowProps}
									rowHoverable={!isDownloadPdf}
								/>}

								{(SinceLaunchData2?.length > 0 || SinceDataLoading) && <ProgressView title='Live2' sorter isDownloadPdf={isDownloadPdf}
									data={SinceLaunchData2} isLoading={SinceDataLoading}
									preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
									onRow={getTouchpointRowProps}
									rowHoverable={!isDownloadPdf}
								/>}
							</>
						)}

						{!isDownloadPdf && ShowMap && <div style={{ position: "sticky", top: 20, alignSelf: "flex-start", height: "fit-content" }}>
							{ShowMap && <MapRender
								data={mergeLiveData ? mergeLiveDataArrays(SinceLaunchData1, SinceLaunchData2) : [...SinceLaunchData1, ...SinceLaunchData2]}
								AirportsLoc={AllAirportData}
								activeAirportCode={hoveredTouchpointAirport}
							/>}
						</div>}
					</div>
				</div>


				{(AppPercData1?.length > 0 && AppPercData2?.length > 0) && <div id="AppPercData1" className='html2pdf__page-break'>
					<RenderTitle title="Total Pax & DY Pax & DY App"
						idName="AppPercData1" exportName={"Total DY - DY Pax"}
						exportData={{ "Live1": AppPercData1, "Live2": AppPercData2 }}
						preferredOrder={["Airport", "Total Pax", "DY Pax %", "APP %"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px" }}>
						{mergeLiveData ? (
							<ProgressView title='Combined Live Data' sorter isDownloadPdf={isDownloadPdf}
								data={mergeLiveDataArrays(AppPercData1, AppPercData2)} isLoading={AppPercDataLoading}
								preferredOrder={["Airport", "Total Pax", "DY Pax %", "APP %"]} />
						) : (
							<>
								{(AppPercData1?.length > 0 || AppPercDataLoading) && <ProgressView title='Live1' sorter isDownloadPdf={isDownloadPdf}
									data={AppPercData1} isLoading={AppPercDataLoading}
									preferredOrder={["Airport", "Total Pax", "DY Pax %", "APP %"]} />}

								{(AppPercData2?.length > 0 || AppPercDataLoading) && <ProgressView title='Live2' sorter isDownloadPdf={isDownloadPdf}
									data={AppPercData2} isLoading={AppPercDataLoading}
									preferredOrder={["Airport", "Total Pax", "DY Pax %", "APP %"]} />}
							</>
						)}
					</div>

					<RenderLastSoMonths />
				</div>}


				{(LastMonthsData1?.length > 0 || AppPercDataLoading) && <div id="LastMonthsData1" className='html2pdf__page-break'>
					<RenderTitle title={mergeLiveData ? "DY Touch Points (Combined)" : "DY Touch Points (Live1)"}
						idName="LastMonthsData1" exportName={mergeLiveData ? "DY Touch Points (Combined)" : "DY Touch Points (Live1)"}
						exportData={{
							...(mergeLiveData ?
								LastMonthsData1?.map((data, index) => {
									const tempMonth = LastMonths?.[index]?.month;
									return { [tempMonth]: mergeLiveDataArrays(data, LastMonthsData2?.[index] || []) };
								}).reduce((acc, curr) => ({ ...acc, ...curr }), {}) :
								LastMonthsData1?.reduce((acc, data, index) => {
									const tempMonth = LastMonths?.[index]?.month;
									acc[tempMonth] = data;
									return acc;
								}, {})
							)
						}}
						preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: `repeat(${MonthsNumber}, 1fr)` }}>
						{mergeLiveData ? (
							// When merged, show a single combined table for each month
							LastMonthsData1?.map((data, index) => {
								const tempYear = LastMonths?.[index]?.year;
								const tempMonth = LastMonths?.[index]?.month;
								const mergedData = mergeLiveDataArrays(data, LastMonthsData2?.[index] || []);
								const prefOrder = ["Airport", "Entry", "SHA", "BOARDING"];
								if (index > 0) {
									prefOrder.shift();
								}

								return (
									<ProgressView
										key={`${tempMonth}-${tempYear}`}
										isLoading={AppPercDataLoading}
										index={index}
										totalLength={LastMonthsData1?.length}
										isDownloadPdf={isDownloadPdf}
										ignoreFirstIndexing
										title={`${tempMonth || ""}-${tempYear || ""}`}
										data={mergedData}
										preferredOrder={prefOrder}
									/>
								);
							})
						) : (
							// When not merged, show Live1 data
							LastMonthsData1?.map((data, index) => {
								const tempYear = LastMonths?.[index]?.year;
								const tempMonth = LastMonths?.[index]?.month;
								const prefOrder = ["Airport", "Entry", "SHA", "BOARDING"];
								if (index > 0) {
									prefOrder.shift();
								}

								return (
									<ProgressView
										key={`${tempMonth}-${tempYear}`}
										isLoading={AppPercDataLoading}
										index={index}
										totalLength={LastMonthsData1?.length}
										isDownloadPdf={isDownloadPdf}
										ignoreFirstIndexing
										title={`${tempMonth || ""}-${tempYear || ""}`}
										data={data}
										preferredOrder={prefOrder}
									/>
								);
							})
						)}
					</div>

					<RenderLastSoMonths />
				</div>}

				{!mergeLiveData && (LastMonthsData2?.length > 0 || AppPercDataLoading) && <div id="LastMonthsData2" className='html2pdf__page-break'>
					<RenderTitle title="DY Touch Points (Live2)"
						idName="LastMonthsData2" exportName={"DY Touch Points (Live2)"}
						exportData={{
							...LastMonthsData2?.reduce((acc, data, index) => {
								const tempMonth = LastMonths?.[index]?.month;
								acc[tempMonth] = data;
								return acc;
							}, {})
						}}
						preferredOrder={["Airport", "Entry", "SHA", "BOARDING"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: `repeat(${MonthsNumber}, 1fr)` }}>
						{LastMonthsData2?.map((data, index) => {
							const tempYear = LastMonths?.[index]?.year;
							const tempMonth = LastMonths?.[index]?.month;
							const prefOrder = ["Airport", "Entry", "SHA", "BOARDING"];
							if (index > 0) {
								prefOrder.shift();
							}

							return (
								<ProgressView
									key={`${tempMonth}-${tempYear}`}
									isLoading={AppPercDataLoading}
									index={index}
									totalLength={LastMonthsData2?.length}
									isDownloadPdf={isDownloadPdf}
									ignoreFirstIndexing
									title={`${tempMonth || ""}-${tempYear || ""}`}
									data={data}
									preferredOrder={prefOrder}
								/>
							);
						})}
					</div>

					<RenderLastSoMonths />
				</div>}

				{(APALData1?.length > 0 || APALUsageLoading) && <div id='APALData1' className='html2pdf__page-break'>
					<RenderTitle title={mergeLiveData ? "Airline DY Pax (Combined)" : "Airline DY Pax (Live1)"}
						idName="APALData1" exportName={mergeLiveData ? "Airline DY Pax (Combined)" : "Airline DY Pax (Live1)"}
						exportData={{ "Live1": APALData1, "Live2": APALData2 }}
						preferredOrder={APALDataColNames1}
					/>

					{mergeLiveData ? (
						<ProgressView title='Combined Live Data' ignoreFirstIndexing sorter isDownloadPdf={isDownloadPdf}
							data={mergeLiveDataArrays(APALData1, APALData2)} isLoading={APALUsageLoading}
							preferredOrder={APALDataColNames1} />
					) : (
						<ProgressView title='Live1' ignoreFirstIndexing sorter isDownloadPdf={isDownloadPdf}
							data={APALData1} isLoading={APALUsageLoading}
							preferredOrder={APALDataColNames1} />
					)}
				</div>}

				{!mergeLiveData && (APALData2?.length > 0 || APALUsageLoading) && <div id='APALData2' className='html2pdf__page-break'>
					<RenderTitle title="Airline DY Pax (Live2)"
						idName="APALData2" exportName={"Airline DY Pax (Live2)"}
						exportData={{ "Live1": APALData1, "Live2": APALData2 }}
						preferredOrder={APALDataColNames2}
					/>

					<ProgressView title='Live2' ignoreFirstIndexing sorter isDownloadPdf={isDownloadPdf}
						data={APALData2} isLoading={APALUsageLoading}
						preferredOrder={APALDataColNames2} />
				</div>}


				<div id="ALSinceLaunchData1" className='html2pdf__page-break'>
					<RenderTitle title="Airlines" idName="ALSinceLaunchData1" exportName="Airlines"
						exportData={{
							"Since Launch": ALSinceLaunchData1,
							...ALSinceLaunchData2  // Now this will contain data for all years, formatted as {year: data, year: data}
						}}
						preferredOrder={["Airline", "Entry", "DY %"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: Object.keys(ALSinceLaunchData2)?.length > 1 ? "repeat(3, 1fr)" : "repeat(2, 1fr)", gap: "16px" }}>
						<ProgressView title='Since Launch' isDownloadPdf={isDownloadPdf}
							data={ALSinceLaunchData1} isLoading={ALSinceLaunchDataLoading}
							preferredOrder={["Airline", "Entry", "DY %"]} />

						{
							// Render the data for each year
							Object.keys(ALSinceLaunchData2).map(year => (
								<ProgressView key={year} title={year} isDownloadPdf={isDownloadPdf}
									data={ALSinceLaunchData2[year]} isLoading={ALSinceLaunchDataLoading}
									preferredOrder={["Airline", "Entry", "DY %"]} />
							))
						}
					</div>
				</div>


				<div id="ALLastMonthsData1" className='html2pdf__page-break'>
					<RenderTitle title={DashboardFilterFormik.values?.Year?.length > 0 ? "Airlines (Last Selected Months)" : `Airlines (Last ${MonthsNumber} Months)`}
						idName="ALLastMonthsData1" exportName={DashboardFilterFormik.values?.Year?.length > 0 ? "Airlines (Last Selected Months)" : `Airlines (Last ${MonthsNumber} Months)`}
						exportData={{
							...ALLastMonthsData1?.reduce((acc, data, index) => {
								const tempMonth = LastMonths?.[index]?.month;  // Extract month name
								acc[tempMonth] = data;  // Use month as key and data as value
								return acc;
							}, {})
						}}
						preferredOrder={["Airline", "Entry", "DY %"]}
					/>

					<div style={{ position: "relative", display: "grid", gridTemplateColumns: `repeat(${MonthsNumber}, 1fr)` }}>
						{ALLastMonthsData1?.map((data, index) => {
							const tempYear = LastMonths?.[index]?.year
							const tempMonth = LastMonths?.[index]?.month
							const prefOrder = ["Airline", "Entry", "DY %"]
							if (index > 0) {
								prefOrder.shift()
							}

							return <ProgressView isLoading={ALLastMonthsLoading} index={index} totalLength={LastMonthsData2?.length} isDownloadPdf={isDownloadPdf}
								ignoreFirstIndexing title={`${tempMonth || ""}-${tempYear || ""}`} data={data} preferredOrder={prefOrder} />
						})}
					</div>

					<RenderLastSoMonths />
				</div>

				<div style={{ textAlign: "center", marginTop: "30px", marginBottom: "20px" }}>
					Updated: {LastUpdatedTime}
				</div>
			</div>

		</CustomCard>
	)
}

export default ReportPage;
